import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core'
import { classes } from 'src/utils/css'

@Component({
  tag: 'call-list-right-column-tabs',
})
export class CallListRightColumnTabs {
  @Event() tabSelected: EventEmitter<string>

  @Prop() selectedTab: string
  @Prop() tabs: readonly { value: string; label: string }[]

  render() {
    return (
      <Host class='flex overflow-hidden flex-col ml-3 h-full'>
        <ul class='flex relative flex-shrink-0 w-full'>
          {this.tabs.map((tab) => {
            const active = this.selectedTab === tab.value
            return (
              <li key={tab.value} class='z-10'>
                <button
                  onClick={() => this.tabSelected.emit(tab.value)}
                  class={`
                    py-3 px-4 text-xl font-extrabold transition duration-200
                    hover:bg-opacity-5 hover:bg-brand hover:text-brand
                    ${classes(active, 'text-brand bg-brand bg-opacity-5 border-brand', 'text-gray-60')}
                  `}
                  style={{ borderBottomWidth: active ? '3px' : null }}
                >
                  {tab.label}
                </button>
              </li>
            )
          })}
          <span class='absolute inset-x-0 bottom-0 h-0.5 bg-gray-700' />
        </ul>
        <div class='flex overflow-hidden flex-col flex-1 mt-1'>
          <slot />
        </div>
      </Host>
    )
  }
}
